// Lightweight client-side search history (localStorage).
// Tracks recent number-searches per browser so we can surface "trending" numbers.

const KEY = "gd_search_history_v1";
const MAX_ENTRIES = 200;
const WINDOW_DAYS = 7;

// Storage failures (private mode / quota) are expected and non-fatal —
// log once instead of spamming the console on every search.
let warnedStorage = false;
function warnStorageOnce(err) {
  if (!warnedStorage) {
    warnedStorage = true;
    console.warn("[gemkey] localStorage unavailable — search history disabled.", err);
  }
}

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch (err) {
    warnStorageOnce(err);
    return [];
  }
}

function write(arr) {
  try {
    localStorage.setItem(KEY, JSON.stringify(arr.slice(-MAX_ENTRIES)));
  } catch (err) {
    warnStorageOnce(err);
  }
}

export function recordSearch(value) {
  const history = read();
  history.push({ value: Number(value), t: Date.now() });
  write(history);
}

export function getTrending(minCount = 3) {
  const cutoff = Date.now() - WINDOW_DAYS * 24 * 60 * 60 * 1000;
  const recent = read().filter((e) => e.t >= cutoff);
  const counts = new Map();
  for (const e of recent) counts.set(e.value, (counts.get(e.value) || 0) + 1);
  return Array.from(counts.entries())
    .filter(([, c]) => c >= minCount)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 8)
    .map(([value, count]) => ({ value, count }));
}

export function getHistoryCount(value) {
  const cutoff = Date.now() - WINDOW_DAYS * 24 * 60 * 60 * 1000;
  return read().filter((e) => e.t >= cutoff && e.value === value).length;
}

export function clearHistory() {
  try {
    localStorage.removeItem(KEY);
  } catch (err) {
    warnStorageOnce(err);
  }
}
